import get from "lodash/get";
import { Img } from "./Image";
import { Topic } from "./Topic";

export class Chapter {
  constructor(node) {
    this.slug = get(node, `slug`);
    this.title = get(node, `title`);
    this.mainImage = new Img(get(node, `mainImage`));
    //this.squareImage = new Img(get(node, `squareImage`));
    this.jumpText = get(node, `subText.json`);
    //this.wideImage = new Img(get(node, `wideImage`));
    this.topics = get(node, `topics`, []).map((t) => new Topic(t));
  }
}
